import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useEffect } from "react";
import HomePage from "./pages/HomePage_Premium";
import AboutPage from "./pages/AboutPage";
import AdmissionPage from "./pages/AdmissionPage";
import ContactPage from "./pages/ContactPage";
import NoticesPage from "./pages/NoticesPage";
import LoginPage from "./pages/LoginPage";
import VerifyOTPPage from "./pages/VerifyOTPPage";
import ParentDashboardPage from "./pages/ParentDashboardPage";
// import AddStudentPage from "./pages/AddStudentPage"; // Removed - now in Manage Students
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import ManageNoticesPage from "./pages/ManageNoticesPage";
import StudentsManagementPage from "./pages/StudentsManagementPage";
import TeacherLoginPage from "./pages/TeacherLoginPage";
import TeacherDashboardPage from "./pages/TeacherDashboardPage";
import ManageTeachersPage from "./pages/ManageTeachersPage";
import ManageHomepageImagesPage from "./pages/ManageHomepageImagesPage";
import AdminSettingsPage from "./pages/AdminSettingsPage";
import AdmissionSettingsPage from "./pages/AdmissionSettingsPage";
import MessagesPage from "./pages/MessagesPage";
import TestimonialsManagementPage from "./pages/TestimonialsManagementPage";
import InstallPWA from "./components/InstallPWA";
import OfflineIndicator from "./components/OfflineIndicator";
import * as pwaUtils from "./utils/pwaUtils";
import { checkVersion } from "./utils/cacheBuster";

function App() {
  // HTTPS Enforcement
  useEffect(() => {
    // Redirect HTTP to HTTPS (client-side enforcement)
    if (window.location.protocol === 'http:' && 
        window.location.hostname !== 'localhost' && 
        window.location.hostname !== '127.0.0.1') {
      window.location.href = window.location.href.replace('http:', 'https:');
    }
  }, []);

  // Check version and clear cache if needed
  useEffect(() => {
    checkVersion();
  }, []);

  // Register service worker on app load
  useEffect(() => {
    if (process.env.NODE_ENV === 'production' || process.env.REACT_APP_ENABLE_PWA === 'true') {
      pwaUtils.register();
      console.log('[PWA] Service worker registration initiated');
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/admission" element={<AdmissionPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/notices" element={<NoticesPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/verify-otp" element={<VerifyOTPPage />} />
          <Route path="/dashboard" element={<ParentDashboardPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route path="/admin/notices" element={<ManageNoticesPage />} />
          {/* Add Student removed - now handled in Manage Students page */}
          {/* <Route path="/admin/students/add" element={<AddStudentPage />} /> */}
          <Route path="/admin/students" element={<StudentsManagementPage />} />
          <Route path="/admin/students/manage" element={<StudentsManagementPage />} />
          <Route path="/admin/manage-teachers" element={<ManageTeachersPage />} />
          <Route path="/admin/homepage-images" element={<ManageHomepageImagesPage />} />
          <Route path="/admin/settings" element={<AdminSettingsPage />} />
          <Route path="/admin/admission-settings" element={<AdmissionSettingsPage />} />
          <Route path="/admin/messages" element={<MessagesPage />} />
          <Route path="/admin/testimonials" element={<TestimonialsManagementPage />} />
          
          {/* Teacher Routes */}
          <Route path="/teacher-login" element={<TeacherLoginPage />} />
          <Route path="/teacher-dashboard" element={<TeacherDashboardPage />} />
        </Routes>
        
        {/* PWA Install Prompt */}
        <InstallPWA />
        
        {/* Offline Indicator */}
        <OfflineIndicator />
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
